import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CommonHelperService {
    proofPrev: any;

    constructor() { }

    signatures: { [key: string]: string } = {
        JVBERi0: "application/pdf",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpg",
    };

    getBlob(baseFile: any) {
        if (!baseFile || typeof baseFile !== 'string') return undefined;
        // If already a data URI, extract the raw base64 part
        if (baseFile.startsWith('data:')) {
            const commaIdx = baseFile.indexOf(',');
            if (commaIdx !== -1) baseFile = baseFile.slice(commaIdx + 1);
        }
        var mimeType = this.detectMimeType(baseFile);
        if (mimeType) {
            var blob = this.b64toBlob(baseFile, mimeType);
            this.proofPrev = URL.createObjectURL(blob);
            return this.proofPrev;
        }
    }

    public detectMimeType(b64: any): string | undefined {
        if (!b64 || typeof b64 !== 'string') {
            return undefined;
        }
        for (var s in this.signatures) {
            if (b64.indexOf(s) === 0) {
                return this.signatures[s];
            }
        }

        return undefined;
    }

    public b64toBlob(b64Data: any, contentType: string): Blob {
        contentType = contentType || '';
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}
